import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";

import TermsAndConditions from "./Pages/TermsAndConditions";
import LetConnects from "./Pages/LetConnects";
import WelcomePage from "./Pages/WelcomePage";
import LandingPage from "./Pages/LandingPage";
import PlateformAbout from "./Pages/PlateformAbout";
import ProtectedRoute from "./components/ProtectedRoute";
// Brochure
function ScrollToSection() {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.pathname.replace("/", "").replace(/\s+/g, "-");
    if (sectionId) {
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Delay ensures section is rendered before scrolling
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToSection />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<TermsAndConditions />} />
        <Route path="/contact-us" element={<LandingPage />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/product" element={<LandingPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/letconnect" element={<LetConnects />} />
        <Route path="/pricing" element={<LandingPage />} />
        <Route
          path="/platform-overview"
          element={
            <ProtectedRoute>
              <PlateformAbout />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
